import Link from "next/link";
import { getGlobalData } from "utils/api";

import Layout from "@/components/layout";
import styles from "@/styles/error.module.scss";

export default function Custom500({ global, basic }) {
  if (basic) {
    return (
      <div className="flex flex-col text-center gap-7 py-24 md:py-32">
        <h1 className={styles.title}>500</h1>
        <h5 className={styles.subTitle}>Something went wrong</h5>
        <p className={styles.text}>
          Sorry, we can&apos;t find the page you&apos;re looking for.
        </p>
      </div>
    );
  }

  return (
    <Layout global={global} isModified>
      <div className="flex flex-col text-center gap-7 py-24 md:py-32">
        <h1 className={styles.title}>500</h1>
        <h5 className={styles.subTitle}>Something went wrong</h5>
        <p className={styles.text}>
          Sorry, we can&apos;t find the page you&apos;re looking for.
        </p>
        <Link href="/">
          <button className={styles.button}>Go to homepage</button>
        </Link>
      </div>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const { locale } = context;
  const globalLocale = await getGlobalData(locale);

  return {
    props: {
      global: globalLocale.data,
    },
  };
}
